import "./NlpSideBarSearchBar.css";
import React, {useEffect, useState} from "react";

const NlpSideBarSearchBar: React.FC = () => {

    return (
        <div className="NlpSideBarSearchBar">
            <input
                className="NlpSideBar__search-input"
                type="text"
                placeholder="חיפוש מטופל/ת"
                dir="rtl"
            />
        </div>
    );
};

export default NlpSideBarSearchBar;
